import React, { Component } from "react";
import { isEmail } from "../../../../_utils";
import { Link } from "react-router-dom";
export default class CreateAccount extends Component {
  state = { email: "", password: "", confirmPass: "" };
  _handleSubmit = event => {
    event.preventDefault();
    const { onCreateAccount } = this.props;
    const { email, password } = this.state;
    onCreateAccount({ email, password });
  };
  getDisableState = () => {
    const { email, password, confirmPass } = this.state;
    if (!isEmail(email)) {
      return true;
    }
    if (!password || !confirmPass) {
      return true;
    }
    if (password !== confirmPass) {
      return true;
    }

    return false;
  };
  render() {
    const { onLogin } = this.props;
    const { email, password, confirmPass } = this.state;
    return (
      <div class="dev-page-login-block__form">
        <form onSubmit={this._handleSubmit}>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group margin-top-30">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={event => {
                    this.setState({ email: event.target.value });
                  }}
                />
              </div>
              <div class="form-group">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  name="password"
                  value={password}
                  onChange={event => {
                    this.setState({ password: event.target.value });
                  }}
                />
              </div>
              <div class="form-group">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Repeat Password"
                  name="re_password"
                  value={confirmPass}
                  onChange={event => {
                    this.setState({ confirmPass: event.target.value });
                  }}
                />
              </div>
            </div>
          </div>

          <div class="form-group no-border">
            <button
              class="btn btn-danger btn-block"
              disabled={this.getDisableState()}
            >
              Sign up
            </button>
          </div>

          <p>
            By clicking Sign Up, you agree to our
            <a
              href="https://amst.co.in/terms-of-use.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong style={{ textDecoration: "underline" }}>
                {" "}
                Terms of Use{" "}
              </strong>
            </a>
            and
            <a
              href="https://amst.co.in/privacy-policy.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong style={{ textDecoration: "underline" }}>
                {" "}
                Privacy Policy
              </strong>
            </a>
            . You may receive SMS Notifications from us and can opt out any
            time.
          </p>
          <p class="text-center">OR</p>
          <div class="form-group no-border">
            <Link
              to={`/login`}
              className="btn btn-success btn-block"
              type="button"
              onClick={onLogin}
            >
              Login
            </Link>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/Login/CreateAccount/index.js